import { ISOTimeStamp } from "../../../../../../library/ts/vanilla/time/ISOTimeStamp";
import { ReminderEntry, ReminderEntryType } from "./ReminderEntry";

export class MailEntry extends ReminderEntry
{  
  date:string;
  utcOffsetMinutes:number;
  subject:string;
  message:string;

  static create()
  {
    let me = new MailEntry();
    me.utcOffsetMinutes = new Date().getTimezoneOffset();
    ReminderEntry.initialize( me );

    return me;
  }
}